import React, { useRef, useEffect } from 'react';
import './DeviceFrameCanvas.css'

interface DeviceFrameCanvasProps {
  frameSrc: string;
  screenshotSrc: string;
  screenX: number;
  screenY: number;
  screenWidth: number;
  screenHeight: number;
}

const DeviceFrameCanvas: React.FC<DeviceFrameCanvasProps> = ({
  frameSrc,
  screenshotSrc,
  screenX,
  screenY,
  screenWidth,
  screenHeight,
}) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas?.getContext('2d');
    if (!ctx) return;

    const frameImg = new Image();
    const screenshotImg = new Image();

    let imagesLoaded = 0;
    const onImageLoad = () => {
      imagesLoaded++;
      if (imagesLoaded < 2) return;

      // Set canvas size to frame size
      canvas!.width = frameImg.width;
      canvas!.height = frameImg.height;

      // Draw screenshot, scaled to fit
      const aspectRatio = screenshotImg.width / screenshotImg.height;

      let drawWidth = screenWidth;
      let drawHeight = drawWidth / aspectRatio;

      if (drawHeight > screenHeight) {
        drawHeight = screenHeight;
        drawWidth = drawHeight * aspectRatio;
      }

      const offsetX = screenX + (screenWidth - drawWidth) / 2;
      const offsetY = screenY + (screenHeight - drawHeight) / 2;

      ctx.clearRect(0, 0, canvas!.width, canvas!.height);
      ctx.drawImage(screenshotImg, offsetX, offsetY, drawWidth, drawHeight);
      ctx.drawImage(frameImg, 0, 0);
    };

    frameImg.onload = onImageLoad;
    screenshotImg.onload = onImageLoad;

    console.log({screenshotSrc, frameSrc})

    frameImg.src = frameSrc;
    screenshotImg.src = screenshotSrc;
  }, [frameSrc, screenshotSrc, screenX, screenY, screenWidth, screenHeight]);

  return <canvas ref={canvasRef} />;
};

export default DeviceFrameCanvas;
